<template>
  <div class="material-article">
    <!-- <el-button @click="goback()" style="marginBottom:24px;">返回</el-button> -->

    <el-descriptions
      border
      class="article"
      :column=1
      :data="tableData">
      <el-descriptions-item label="所属类别" v-if="tableData.first_catname">{{tableData.first_catname}}&nbsp;<i class="el-icon-right"></i>&nbsp;{{tableData.second_catname}}</el-descriptions-item>
      <el-descriptions-item label="原料编号" v-if="tableData.ylcode"><div v-html="tableData.ylcode"></div></el-descriptions-item>
      <el-descriptions-item label="中文名称" v-if="tableData.title"><div v-html="tableData.title"></div></el-descriptions-item>
      <el-descriptions-item label="特征描述" v-if="tableData.content"><div v-html="tableData.content"></div></el-descriptions-item>
      <el-descriptions-item label="强制性标识" v-if="tableData.bsyq"><div v-html="tableData.bsyq"></div></el-descriptions-item>
      <!-- <el-descriptions-item label="申请单位" v-if="tableData.danwei">{{tableData.danwei}}</el-descriptions-item> -->
      <el-descriptions-item label="法规来源" v-if="tableData.laiyuan">
        <div v-if="lyUrl">
            <a :href="lyUrl[index]" target="_blank" style="display: block;" v-for="(item, index) in sourceName" :key="index">{{item}}</a>
        </div>
        <div v-if="!lyUrl"><a target="_blank" v-html="tableData.laiyuan"></a></div>
      </el-descriptions-item>
      <el-descriptions-item label="申请公司" v-if="tableData.danwei"><div v-html="tableData.danwei"></div></el-descriptions-item>
      <el-descriptions-item label="实施日期" v-if="tableData.fromtime"><div v-html="tableData.fromtime"></div></el-descriptions-item>
      <el-descriptions-item label="官网链接" v-if="tableData.lyurl">
        <a :href="item" target="_blank" style="display: block; word-break: break-all;" v-for="(item, index) in officialWebsiteUrl" :key="index">{{item}}</a>
      </el-descriptions-item>
      <el-descriptions-item label="备注" v-if="tableData.remark"><div v-html="tableData.remark"></div></el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        tableData: {},
        url: '',
        lyUrl:'',
        officialWebsiteUrl:[],
        sourceName: []
      }
    },
    created () {
      // 接收material传过来的itemid
      this.itemid = this.$route.query.itemid
      this.initTableData();
    },
    methods: {
		toLaiyuan(){
			var host = decodeURIComponent(this.getCookie('syy_domain'))
			var host2 = this.getCookie('quanxian')
			if(host && host2 == 20){
				var cookie_value = this.getCookie('tjj');
				var type = this.tableData.fg_lyid?'fg':'bz';
				var itemid = this.tableData.fg_lyid?this.tableData.fg_lyid.split('<br/>'):this.tableData.bz_lyid.split('<br/>');
				if(type == 'fg'){
					if (cookie_value == 1){
                        for(var item in itemid){
                                var base_url = [];
                                base_url.push(host+"/home/biaofa.biaofa_list/faguicontent?quanku=1&itemid="+itemid[item])
                            }
					}else {
                        for(var item in itemid){
                            var base_url = [];
                            base_url.push(host+"/home/biaofa.fagui/content?quanku=1&itemid="+itemid[item])
                        }
					}
				}else if(type == 'bz'){
					if (cookie_value == 1){
                        for(var item in itemid){
                            var base_url = [];
                            base_url.push(host+"/home/biaofa.biaofa_list/biaozhuncontent?quanku=1&itemid="+itemid[item])
                        }
					}else {
                        for(var item in itemid){
                            var base_url = [];
                            base_url.push(host+"/home/biaofa.biaozhun/content?quanku=1&itemid="+itemid[item])
                        }
					}
				}
				this.lyUrl = base_url
			}else{
        var itemid = this.tableData.hbfg_lyid.split('<br/>');
        var url=[];
        for(var item in itemid){
          url.push(`http://law.foodmate.net/show-${this.tableData.hbfg_lyid.split('<br/>')[item]}.html`)
        }
        this.lyUrl = url;
			}
		},
		getCookie(cookie_name) {
			// var allcookies = document.cookie;
			// //索引长度，开始索引的位置
			// var cookie_pos = allcookies.indexOf(cookie_name);
			// // 如果找到了索引，就代表cookie存在,否则不存在
			// if (cookie_pos != -1) {
			// 	// 把cookie_pos放在值的开始，只要给值加1即可
			// 	//计算取cookie值得开始索引，加的1为“=”
			// 	cookie_pos = cookie_pos + cookie_name.length + 1;
			// 	//计算取cookie值得结束索引
			// 	var cookie_end = allcookies.indexOf(";", cookie_pos);
			// 	if (cookie_end == -1) {
			// 		cookie_end = allcookies.length;

			// 	}
			// 	//得到想要的cookie的值
			// 	var value = unescape(allcookies.substring(cookie_pos, cookie_end));
			// }
			// return value;

      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${cookie_name}=`);
      if (parts.length === 2) {
        return parts[1].split(';')[0].trim(); // 取第二个元素，分割后取第一个值并去空格
      }
      return null; // 未找到
		},
      initTableData(){
        this.$ajax.get('https://api.sy.foodvip.net/?c_key=de5cd2297c84684b&func_name=feed_ngredients_content&itemid=' + this.itemid,{itemid: this.itemid}).then(resp=>{
          console.log(resp.data.data);
          if(resp){
            this.tableData = resp.data.data;
            this.officialWebsiteUrl = resp.data.data.lyurl.split('<br/>');
            this.sourceName = resp.data.data.laiyuan.split('<br/>');
			this.toLaiyuan()
			// this.url = `http://fmtcomply.sy.foodvip.net/home/biaofa.fagui/content.html?itemid=${this.itemid}`
          }
        })
      },
      goback(){
        this.$router.back();
      }
    }
  }
</script>

<style>
.material-article{
  padding: 30px 0 40px;
  min-height: auto !important;
}
a{
  color: #1966A7;
  text-decoration: none;
}
.article .el-descriptions__body{
  font-size: 14px;
  color: #333;
}
.article th{
  min-width: 160px;
  box-sizing: border-box;
}
.article .el-descriptions-item__label.is-bordered-label{
  color: #333;
}
.article.el-descriptions .is-bordered .el-descriptions-item__cell {
  padding: 12px 30px;
}
@media screen and (max-width: 750px) {
  .el-descriptions .is-bordered{
    table-layout: fixed;
  }
  .article th{
    width: 100px;
    min-width: auto;
  }
  .article.el-descriptions .is-bordered .el-descriptions-item__cell {
    padding: 8px 12px;
  }
}
</style>
<style scoped>
.el-main{
  padding-bottom: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/material_article.vue